// OCR's sign that one uploaded file holds several receipts or invoices. Its count is only a lower bound, since
// Textract misses receipts turned far off level, so the UI says "several" rather than a number.
export const mayHoldSeveralDocuments = (receiptScan) => receiptScan?.possible_document_count > 1
